// Import model
import { CustomerReviewCondition } from '../models/CustomerReviewCondition';

// Import base class serializer

// Import dependency types (models and enums used in properties)
import { ApiPiConditionOperator } from '../models/ApiPiConditionOperator';
import { CustomerReviewIndexedFields } from '../models/CustomerReviewIndexedFields';

// Import dependency serializers (for complex types)
import { ApiPiConditionOperatorSerializer } from './ApiPiConditionOperatorSerializer';
import { CustomerReviewIndexedFieldsSerializer } from './CustomerReviewIndexedFieldsSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for CustomerReviewCondition - handles JSON serialization and deserialization with type validation
 */
export class CustomerReviewConditionSerializer {
  /**
   * Deserializes a JSON string into a CustomerReviewCondition instance
   */
  static deserialize(json: string): CustomerReviewCondition {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a CustomerReviewCondition instance
   */
  static fromObject(obj: any): CustomerReviewCondition {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to CustomerReviewCondition');
    }


    const instance: CustomerReviewCondition = {
      fieldName: obj['fieldName'] as CustomerReviewIndexedFields | undefined,
      operator: obj['operator'] as ApiPiConditionOperator | undefined,
      value: obj['value'] as any | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of CustomerReviewCondition instances
   */
  static deserializeArray(json: string): CustomerReviewCondition[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a CustomerReviewCondition instance to a JSON string
   */
  static serialize(instance: CustomerReviewCondition): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a CustomerReviewCondition instance to a plain object
   */
  static toObject(instance: CustomerReviewCondition): any {
    return {
      'fieldName': instance.fieldName,
      'operator': instance.operator,
      'value': instance.value,
    };
  }

  /**
   * Serializes an array of CustomerReviewCondition instances to a JSON string
   */
  static serializeArray(instances: CustomerReviewCondition[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
